module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"back":"Zurück","licences":"Lizenzen"},"en":{"back":"Back","licences":"Licences"}}')
  delete Component.options._Ctor
}
